import { useContainerBreakpoints } from '../UNSAFE_useContainerBreakpoints';
import { defaultBreakpoints, Breakpoints } from '../UNSAFE_useBreakpoints';

/*
 * This allows a user to define key/value pairs that map to each breakpoint.
 * The user's custom value is returned when the specific breakpoint is reached.
 */
type DefaultBreakpoints = keyof typeof defaultBreakpoints;
type DefaultType<T> = Record<DefaultBreakpoints, T>;
type Responsive<V> = Partial<DefaultType<V>>;

/*
 * Custom hook to allow the user to define custom values that are returned if a breakpoint is reached.
 * The Responsive object is a set of one or more key/value pairs, with each breakpoint as a key.
 */
export function useContainerBreakpointValues<V>(
  breakpointValues: Responsive<V>,
  breakpoints: Breakpoints = defaultBreakpoints
) {
  const { breakpointMatches, ref } = useContainerBreakpoints(breakpoints);

  const result = Object.entries(breakpointValues).reduce((p, c) => {
    const key = c[0]; // first entry in breakpoint values is the key
    return breakpointMatches[key] ? c : p;  // if current breakpoint is true, return it, else stay with previous
  });

  const breakpoint = result[1]; // second entry in breakpoint values is the value

  return { breakpoint, ref };
}
